import React from "react";
//#region types
import { LighterTitleProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const LighterTitle: React.FC<LighterTitleProps> = (props) => {
  const { title, subTitle } = props;

  return (
    <Grid container className={cssExports.lighterTitle}>
      <Grid container className={cssExports.title}>
        {title}
      </Grid>
      <Grid container className={cssExports.subTitle}>
        {subTitle}
      </Grid>
    </Grid>
  );
};

export default LighterTitle;
